import React from "react";
import CookieConsent from "react-cookie-consent";
import Newnav from "../components/newnav";
import Footer from "../components/footer";
//import Tilt from "react-tilt";
import { Icon } from "@iconify/react";
import mobileOutline from "@iconify/icons-ant-design/mobile-outline";
import qrcodeOutline from "@iconify/icons-ant-design/qrcode-outline";
import RenovationVideos from "../components/renovation-videos";

const sectionStyle = {
  backgroundImage: "url(/static/media/1.a086e620.png)",
  width: "100vw",
  backgroundRepeat: "no-repeat",
  display: "block",
  backgroundSize: "cover",
  backgroundPosition: "center",
  position: "relative",
  marginTop: "120px",
};

class Renovation extends React.Component {
  render() {
    document.body.classList.remove("landing-page");
    document.body.classList.remove("home-style");
    document.body.classList.remove("three");
    document.body.classList.remove("home-style-two");
    return (
      <div>
        {/* Navbar Component*/}
        <Newnav />

        {/* Home One Section Start */}
        <section id="home" style={sectionStyle}>
          <div className="home-decor">
            <div className="home-circle1">
              <img src="assets/images/main-banner3.png" alt="" />
            </div>
            <div className="home-circle2">
              <Icon
                style={{ marginRight: 90, marginTop: 180 }}
                width={50}
                height={50}
                icon={qrcodeOutline}
              />
              {/* <img src="assets/images/main-banner12.png" alt="" /> */}
            </div>
            <div className="home-circle3">
              <Icon width={160} height={280} icon={mobileOutline} />
              {/* <img src="assets/images/main-banner1.png" alt="" /> */}
            </div>
          </div>
          <div className="container">
            <div class="row">
              <div class="col-md-6">
                <h2 className="title">
                  <span>ΑΝΑΚΑΙΝΙΣΕΙΣ ΚΑΤΟΙΚΙΩΝ & ΕΠΑΓΓΕΛΜΑΤΙΚΩΝ ΧΩΡΩΝ</span>
                </h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                {/* <div className="home-contain"> */}
                <div>
                  {/* <h2 className="title">
                    <span>ΑΝΑΚΑΙΝΙΣΕΙΣ ΚΑΤΟΙΚΙΩΝ & ΕΠΑΓΓΕΛΜΑΤΙΚΩΝ ΧΩΡΩΝ</span>
                  </h2> */}
                  <p>
                    Η QRSTAND Design αναλαμβάνει τμηματική και πλήρη ανακαίνιση
                    οποιουδήποτε επαγγελματικού χώρου και οικίας.
                  </p>
                  <p>
                    Η εμπειρία μας στο χώρο των κατασκευών, μας επιτρέπει να
                    σχεδιάσουμε για εσάς ένα ιδανικό περιβάλλον καθιστώντας το
                    ελκυστικό προς την αισθητική σας και λειτουργικό προς τις
                    ανάγκες σας. Σας παρέχουμε πλήρη παρουσίαση της
                    αρχιτεκτονικής μας πρότασης με{" "}
                    <b>σχέδια 3D (φωτορεαλιστικά)</b>
                    για να επιλέξουμε μαζί και να καταλήξουμε στο καλύτερο
                    αποτέλεσμα τόσο αισθητικά όσο και εργονομικά.
                  </p>
                </div>
                {/* </div> */}
              </div>
              <div className="col-md-6">
                <p>
                  Η πολυετή εμπειρία της{" "}
                  <b>CEO Τσεμπερλίδου Παρασκευής και των συνεργατών της</b> στην
                  ανακαίνιση - ανακατασκευή μας επιτρέπει να σας εγγυόμαστε την
                  παράδοση του χώρου σας χωρίς καμία απόκλιση στο προσυμφωνημένο
                  χρονοδιάγραμμα.
                </p>
                <p>
                  Η συνεργασία της QRSTAND Design με εταιρείες όπως{" "}
                  <b>POCELANA , KARE - DESIGN , TOG & TOG</b> και πολλές άλλες
                  αξιόπιστες εταιρείες σε όλη την Ελλάδα, μας δίνει τη
                  δυνατότητα να μπορούμε να πετύχουμε την μέγιστη ποιότητα στην
                  καλύτερη δυνατή τιμή.{" "}
                </p>
                {/* <div className="home-right"> */}
                {/* <Tilt
                    options={{
                      perspective: 110,
                      speed: 400,
                      max: 1.2,
                      scale: 1,
                    }}
                  >
                    <img
                      src="assets/images/mobile.png"
                      className="img-fluid"
                      alt="mobile"
                    />
                  </Tilt> */}
                {/* </div> */}
              </div>
            </div>
          </div>
        </section>
        {/* Home One Section End */}
        <br></br>
        {/*Footer Component*/}
        <RenovationVideos />
        <Footer />
        <CookieConsent
          location="bottom"
          buttonText="Συμφωνώ"
          cookieName="token"
          style={{ background: "#2B373B" }}
          buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
          expires={150}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "start",
              alignItems: "center",
            }}
          >
            Αυτός ο ιστότοπος χρησιμοποιεί cookies για να βελτιώσει την εμπειρία
            του χρήστη.{" "}
            <a
              style={{
                fontSize: "10px",
                color: "#fcc11a",
                textDecoration: "none",
              }}
              className="nav-link"
              href={`${process.env.PUBLIC_URL}/cookiePolicy`}
            >
              Πολιτική Cookies
            </a>
          </div>
        </CookieConsent>
      </div>
    );
  }
}

export default Renovation;



// WEBPACK FOOTER //
// ./src/pages/renovation.js